export default __webpack_public_path__ + "static/media/new-ai-logo-blue.417290c0.svg";